<template>
    <div class="ranking-option-panel d-flex justify-center align-center w-100 position-relative">
        <v-btn
            color="#302656"
            class="px-12 py-5 white--text position-absolute"
            rounded
            style="left: 0;"
            @click="$router.go(-1)"
        >
            <v-icon class="mr-4">mdi-keyboard-return</v-icon>
            {{ $t('go_back') }}
        </v-btn>
        <v-row justify="center">
            <v-col cols="12" class="ma-0 pa-0">
                <v-btn-toggle
                    v-model="rank"
                    tile
                    group
                    borderless
                    mandatory
                    dense
                    @change="changeRanking"
                >
                    <v-btn
                        value="school"
                        class="px-5 pb-3 mx-2 color-text text-subtitle-1 font-weight-bold"
                        :disabled="!ready"
                    >
                        {{ $t('ranking.my_school') }}
                    </v-btn>
                    <v-btn
                        value="global"
                        class="px-8 pb-3 mx-2 color-text text-subtitle-1 font-weight-bold"
                        :disabled="!ready"
                    >
                        {{ $t('ranking.global') }}
                    </v-btn>
                </v-btn-toggle>
            </v-col>
        </v-row>
    </div>
</template>
<script>
import { mapState, mapActions } from 'vuex'

export default {
    props: {
        ready: { type: Boolean, default: true },
    },
    computed: {
        ...mapState({
            rankingMode: (state) => state.rankingMode,
        }),
    },
    data() {
        return {
            rank: 'school',
        }
    },
    mounted() {
        this.rank = this.rankingMode
    },
    methods: {
        ...mapActions(['setRankingMode']),
        changeRanking() {
            this.setRankingMode(this.rank)
        },
    },
}
</script>
<style scoped>
.v-btn-toggle > .v-btn.v-btn--active {
    border-bottom: 10px solid #ff6f3a !important;
    color: #4a3216;
    opacity: 1;
}

.v-btn-toggle > .v-btn {
    border-bottom: 10px solid #ff6f3a;
    color: #4a3216;
    opacity: 0.3;
}
.v-btn:before {
    background-color: white;
}
.v-btn {
    text-transform: none;
}
</style>
